module.exports = __webpack_public_path__ + "img/star-map_bg-2.364a831.png";